import { DestinationAction } from '../../interfaces/destination';
import type { EntityAction } from '../../../entity-actions/interfaces/entity-actions';
import {
  EntityActionHandlerType,
  EntityActionType
} from '../../../entity-actions/interfaces/entity-actions';

export const DESTINATION_INLINE_EDIT_ACTION: EntityAction<DestinationAction.EDIT> = {
  action: DestinationAction.EDIT,
  type: EntityActionType.INLINE,
  actionHandlerType: EntityActionHandlerType.NAVIGATE,
  displayName: 'Edit',
  icon: 'edit'
};

export const DESTINATION_MENU_EDIT_ACTION: EntityAction<DestinationAction.EDIT> = {
  action: DestinationAction.EDIT,
  type: EntityActionType.MENU,
  actionHandlerType: EntityActionHandlerType.NAVIGATE,
  displayName: 'Edit Destination',
  description: 'Updating the Destination Configuration will impact all the associated Pipelines',
  icon: 'edit',
  routeOptions: {
    route: 'edit',
    options: {
      relative: 'route'
    }
  }
};

export const DESTINATION_ACTIONS_DISPLAY_DETAILS: EntityAction<DestinationAction>[] = [
  DESTINATION_MENU_EDIT_ACTION,
  {
    action: DestinationAction.DELETE,
    type: EntityActionType.MENU,
    actionHandlerType: EntityActionHandlerType.CONFIRM,
    displayName: 'Delete Destination',
    icon: 'delete',
    description: 'Once deleted, it would not appear in the Destinations List',
    destructive: true
  }
];
